import React, { Fragment } from 'react';

const Tooltip = ({ text }) => {
    return (
        <Fragment>
            {text &&
                <div className="tool-tip">
                    <i className="icon-info_circle"></i>
                    <div className="tool-tip__content" dangerouslySetInnerHTML={ {__html: text} } />
                </div>
            }
        </Fragment>
    );
};

export default Tooltip;